import styled from "styled-components";

export const FeaturesSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px;
  background-color: ${({ theme }) => theme.colorsPalette.black.default};

  @media (max-width: 600px) {
    flex-direction: column;
    padding: 40px;
  }
`;

export const FeaturesCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 16px;
  max-width: 1200px;
  margin: auto;

  @media (max-width: 600px) {
    max-width: unset;
    margin: unset;
  }
`;

export const FeaturesIconContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  border: 0 solid #000;
  border-radius: 16px;
  margin-bottom: 16px;
`;
